/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/8
 * Description: 文件描述
 */
import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
    routeName: {
        home: 'home',
        applicationList: 'applicationList',
        user: 'user',
        publishArticle: 'publishArticle',
        permissions: 'permissions',
        pageControl: 'pageControl',
        PersonalCenter: 'PersonalCenter',
        personalCenter: 'personalCenter',
        parkingManagement: 'parkingManagement',
        parkingSetup: 'parkingSetup',
        parking: 'parking',
        visitorManagement: 'visitorManagement',
        visitorSetup: 'visitorSetup',
        visitorRegisterRecord: 'visitorRegisterRecord',
        visitorAccessRecord: 'visitorAccessRecord',
        accessManagement: 'accessManagement',
        access: 'access',
        accessSetup: 'accessSetup',
        faceManagement: 'faceManagement',
        face: 'face',
        faceSetup: 'faceSetup',
        // 门禁系统
        personnelManagement: 'personnelManagement',
        personnelList: 'personnelList',
        department: 'department',
        equipmentManagement: 'equipmentManagement',
        faceDevice: 'faceDevice',
        statisticalReports: 'statisticalReports',
        accessRecords: 'accessRecords',
        //人车布控
        controlCenter: 'controlCenter',
        controlTpye: 'controlTpye',
        controlVehicle: 'controlVehicle',
        vehicleWarning: 'vehicleWarning',
        vehicleAcceptance: 'vehicleAcceptance',
        controlPersonnel: 'controlPersonnel',
        PersonnelWarning: 'PersonnelWarning',
        PersonnelAcceptance: 'PersonnelAcceptance',
        FaceWarning: 'FaceWarning',
        FaceAcceptance: 'FaceAcceptance',
        intelligenceWarning: 'intelligenceWarning',
        intelligenceAcceptance: 'intelligenceAcceptance',
        /*安保制度*/
        securitymanagement: 'securitymanagement',
        security: 'security',
        /*信息登记管理*/
        information: 'information',
        informationregistration: 'informationregistration',
        //微信设置
        wechat: 'wechat',
        wechatManagement: 'wechatManagement',
        wechatMessage: "wechatMessage",
        //内保管理
        fileManagement: 'fileManagement',
        fileMessage: 'fileMessage',
        //排班管理
        schedulingManagement: "schedulingManagement",
        schedulingPersonnelManagement: "schedulingPersonnelManagement",
        schedulingSettings: "schedulingSettings",

        /*基础设置*/
        setting: "setting",
        permissionsetting: "permissionsetting",
        unitsetting: "unitsetting",
        usersetting: "usersetting",
        print: "print",
        /*票务基础设置*/
        ticketSetting: "ticketSetting",
        tickesSpot: "tickesSpot",
        ticketScenicname: "ticketScenicname",
        ticketChecking: "ticketChecking",
        ticketGate: "ticketGate",
        ticketEquipment: "ticketEquipment",
        /*票务业务管理*/

        ticketManagement: "ticketManagement",
        ticketMaking: "ticketMaking",
        ticketCard: "ticketCard",
        ticketStorage: "ticketStorage",
        ticketAuthentication: "ticketAuthentication",
        ticketMerchandise: "ticketMerchandise",
        ticketMerchandisekind: "ticketMerchandisekind",
        ticketPreferential: "ticketPreferential",
        ticketMatchingRules: "ticketMatchingRules",
        ticketCompensationPrice: "ticketCompensationPrice",
        ticketBilling: "ticketBilling",
        ticketVenue: "ticketVenue",
        ticketVenuesetup: "ticketVenuesetup",
        ticketVenueplan: "ticketVenueplan",
        ticketTime: "ticketTime",
        ticketGroup: "ticketGroup",
        ticketCalendar: "ticketCalendar",
        ticketControl: "ticketControl",
        ticketTimeSharing: "ticketTimeSharing",
        /*商品管理 */
        goods: "goods",
        commodity: "commodity",
        gatalogue: "gatalogue",
        shops: "shops",
        goodsloading: "goodsloading",
        Inventory: "Inventory",
        Commoditysales: "Commoditysales",
        Salesdetails: "Salesdetails",

        /*库存设置 */
        Warehouse: "Warehouse",
        Entry: "Entry",
        Ticket_Inventory: "Ticket_Inventory",

        /*领票管理 */
        ticketCollection: "ticketCollection",
        ticketWarehouseManagement: "ticketWarehouseManagement",
        ticketCollectionManagement: "ticketCollectionManagement",
        returnManagement: "returnManagement",
        dataStatistics: "dataStatistics",

        /*查询报表*/
        ticketReport: "ticketReport",
        ticketrOrder: "ticketrOrder",
        ticketTicket: "ticketTicket",
        ticketCode: "ticketCode",
        ticketImport: "ticketImport",
        ticketConsume: "ticketConsume",
        ticketActivate: "ticketActivate",
        ticketConsumestate: "ticketConsumestate",
        ticketInventory: "ticketInventory",
        ticketMerchandiseReport: "ticketMerchandiseReport",
        ticketMerchandiseSale: "ticketMerchandiseSale",
        ticketFlow: "ticketFlow",
        ticketStorageReport: "ticketStorageReport",
        Supplementary: "Supplementary",
        ticketInput: "ticketInput",
        ticketType: "ticketType",
        ticketCommodity: "ticketCommodity",
        ticketRefund: "ticketRefund",

        /*股东设置*/
        Stockholder: "Stockholder",
        Shareholder: "Shareholder",
        Share: "Share",
        Statement: "Statement",
        statisticAnalysis: "statisticAnalysis",

        /*系统管理*/
        ticketsystem: "ticketsystem",
        ticketWechat: "ticketWechat",
        ticketAlipay: "ticketAlipay",
        ticketDatabase: "ticketDatabase",
        ticketInformation: "ticketInformation",
        ticketLog: "ticketLog",
        EquipmentUpgrade: "EquipmentUpgrade",
        ticketDetailsRecord: "ticketDetailsRecord",

        /*信息发布管理*/
        release: "release",
        programRelease: "programRelease",
        graphicRelease: "graphicRelease",
        contentRelease: "contentRelease",
        dataRelease: "dataRelease",
        ticketStatements: 'ticketStatements',
        datalist: 'datalist',

        /*旅行社管理*/
        travelAgencyManagement: 'travelAgencyManagement',
        ticketTypeManagement: 'ticketTypeManagement',
        orderManagement: 'orderManagement',
        rechargeManagement: 'rechargeManagement',
        userManagement: 'userManagement',
        financialStatements: 'financialStatements',
        test: 'test',

        /*旅行社菜单*/
        importOrder: 'importOrder',
        travelAgencyOrderManagement_travelAgency: 'travelAgencyOrderManagement_travelAgency',
        travelAgencyRechargeManagement: 'travelAgencyRechargeManagement',

        passenger: 'passenger',
        camera: 'camera',
        statistics: 'statistics',

        /*售票*/
        PrintTickets: "PrintTickets",
        ScanningTicketing: "ScanningTicketing",
        MembershipCard: "MembershipCard",
        StoredCard: "StoredCard",
        Refund: "Refund",
        Collection: "Collection",
        travelAgencyOrderManagement: "travelAgencyOrderManagement",
        Record: "Record",
        Query: "Query",
        Memberrenewal: "Memberrenewal",
        sellPrintTickets: "sellPrintTickets",
        sellPrintTicketsgoods: "sellPrintTicketsgoods",
        sellScanningTicketing: "sellScanningTicketing",
        sellMembershipCard: "sellMembershipCard",
        sellStoredCard: "sellStoredCard",
        sellgoods: "sellgoods",
        sellRefund: "sellRefund",
        sellCollection: "sellCollection",
        sellRecord: "sellRecord",
        sellQuery: "sellQuery",
        sellDifference: "sellDifference",
        sellMemberrenewal: "sellMemberrenewal",
        scan: "scan",
        annualCardActivation: 'annualCardActivation',

        /*旅行社权限*/
        importOrderPlacement: "importOrderPlacement",
    },
    home: {
        text1: "Please enter your login account",
        text2: "Please enter your password",
        text3: "Login",
        text_: 'Welcome to Smart Scenic Spot Ticketing System',
        text: 'Smart scenic spot ticketing system',

        Refund: "Refund",
        Cashrefunded: "Cash refunded",
        Alipayback: "Alipay back",
        RefundWechat: "Refund Wechat",
        RefundUnionPay: "Refund UnionPay",

        text: 'Intelligent ticketing system',
        todayEnterCount: "Number of people entering the park that day",
        todayOfflineTicketCount: "Under the same day ticket purchase line",
        todayOnlineTicketCount: "Buying tickets online on the same day",
        todayWeChatTicketCount: "Number of WeChat tickets purchased that day",
        entercount: "Number of visitors",
        groupTicketCount: "Group ticket",
        cardTicketCount: "Total membership cards",
        ordinaryTicketCount: "Total ordinary tickets",
        enterCount: "Total votes used",
        onlineTicketCount: "Number of online tickets",
        weChatTicketCount: "weChat account number",
        offlineTicketCount: "Number of offline tickets",
        zdj: "Terminal",
        dsf: "Third party",
        type: 'Type analysis',
        Ordinarycard: "Ordinary",
        Membershipcard: "Membership",
        Storedcard: "Stored",
        Ticketstatistics: "Ticket statistics",
        Volume: "Volume",
        Groupcard: "Group card",
        Amount: "amount",
        Transactionanalysis: "Transaction",
        Cash: "Cash",
        WeChat: "WeChat",
        Alipay: "Alipay",
        UnionPay: "UnionPay",
        Monday: "Monday",
        Tuesday: "Tuesday",
        Wednesday: "Wednesday",
        Thursday: "Thursday",
        Friday: "Friday",
        Saturday: "Saturday",
        Sunday: "Sunday",
        Total: "Total",
        Sourceanalysis: "Source",
        OTA: "OTA",
        OfflineWindow: "Offline Window",
        account: "Account",
        Terminal: "Terminal",
        visitorsflowrate: "Passenger flow",
        Touristtype: "Tourist type",
        VIP: 'vip',
        family: "family",

    },
    ticketspot: {
        id: "Id",
        name: "Name of scenic spot",
        errorspot: "The scenic spot name cannot be longer than 16 characters",
        add: "Add scenic spot name",
        placeholdername: "Please enter the name of the scenic spot",
        placeholderremark: "Please enter comments",
        editspot: "Edit scenic spot",



    },
    ticketScenic: {
        LimitCount_: "The limited number of people cannot be greater than 5 characters",
        Scenicname_: 'Please select the name of the scenic',
        ScenicArea_: "Please select a scenic spot",
        ScenicArea: 'Scenic Area',
        LimitEnable: "Is the number of people limited",
        id: "ID",
        LimitCount: "Please enter the number of people",
        name: "Scenic name",
        add: "New attractions",
        placeholdername: "Please enter the name of the attraction",
        placeholderremark: "Please enter the scenic spot notes",
        editspot: "Edit attractions",
        errorspot: "The length of attraction name cannot be greater than 16 characters",
        errorremark: "Note length cannot be greater than 16 characters",
    },
    ticketgate: {
        constStatus: "Door opening mode",

        pt: "Normal mode",

        ck: "Long open",
        cb: "Long closed",
        qx: "Distribution permission",
        id: "Id",
        name: "Equipment name",
        ScenicArea: 'Scenic Area',
        zone: "Scenic spots",
        deviceNo: "Equipment code",
        moduleType: "Equipment type",
        deviceIP: "Device IP",
        online: "Equipment status",
        webPort: "Device port number",
        createTime: "Add date",

        zx: "on-line",
        lx: "off-line",
        kz: "Remote opening",
        qc: "Clear data",
        addgate: "New equipment",
        deviceNo_: "Please enter the device code",
        name_: "Please enter the device name",
        print: "Print template",
        numberzs: "Printing paper",
        numberzs_: "Number of sheets of paper",
        ucOpenDoorType: "Door opening type",
        ucCommuTyp: "485 communication mode",

        uc485Id: "485 communication ID",
        deviceIP_: "Please enter the device IP",
        webPort_: "Please enter the device port number",
        editgate: "Edit device",
        deviceNo_a: "Equipment code cannot be empty",
        name_a: "Device name cannot be empty",
        device_a: "Please select a device type",
        ScenicArea_: "Please select a scenic spot",
        zone_: "Please select a scenic spot name",
        moduleType_: " Please select a device type",
        Ip: " Device IP cannot be empty",
        Ip_: " The device IP format is incorrect",
        Enter: "Enter",
        Out: "Out",
        Gate: "Intelligent channel gate",
        Terminal: "Self service ticket collection terminal",
        Handheld: "Handheld ticket collection terminal",
        relay: "Relay door opening",
        gateplate: "Gate plate opening",
        control: "Access control",
        Enable: "Enable",
        Disable: "Disable",
        Import: "Import",
        Export: "Export",
        scope: "This operation will control the equipment to open the door once. Do you want to continue?",
        door: "Open the door successfully",
        failure: "Door opening failure",
        Cancel: "Cancel operation",
        scope_: "This operation will clear the database in the ticket controller. After clearing, you need to re edit the ticket type permission in the changed equipment and ticket type management. Do you want to continue?",
        qxscope: "This operation will distribute ticket type parameters, ticket data, ticket corresponding permissions, and other parameters to the equipment. Do you want to continue?",
        qxscope_: "Issued successfully",
        qxscope_a: "Distribution failed",

        Cleared: "Cleared successfully",
        Cleared_: "Clearing failed",
        IDuc485Id_: "  The size cannot be greater than 255",
        deviceNo_: " The device name cannot be longer than 16 characters",
        ucOpenDoorType_: "Please select the door opening type",

        IDuc485Id_a: "485 communication mode cannot be empty",
        IDuc485Id_b: "485id cannot be empty",
        print_: "Please select a print template",
        printTicketCount: "Number of printed sheets cannot be blank",
        deviceIPlength: "IP length cannot be greater than 15 characters",
        namelength: "The device name cannot be longer than 16 characters",
    },
    ticketmaking: {
        id: "ID",
        name: "Ticket type name",
        ticketPrice: "Ticket price",
        ticketMedium: "Ticket medium",
        ticketCate: "Ticket category",
        ticketFeeMethod: "Billing method",
        scenicAreaID: "Scenic Area",
        scenicAreaID_: "Scenic spot ID",
        ticketZone_query: "Ticket authority",

        add: "New ticket type",
        ticketTypeName: "Ticket name",
        ticketTypeName_: "Please enter ticket name",
        ticketDisplayPrice: "External sales price",
        ticketDisplayPrice_: "Please enter the ticket price for external sales",

        ticketPrice_: "Please enter ticket price",

        ticketTypeStartingType: "Starting method",
        ticketTypeStartingDate: "Starting date",
        date: "Select date",
        ticketUseDays: "Validity period (days)",
        refundRuleID: "Refund rules",
        limitCount: "Wechat restrictions",
        limitCount_: "When it is 0, there is no limit by default",
        patchCard: "Card replacement fee",
        checkVal: "Loading platform",
        checkbox1: "official account",
        checkbox2: "Terminal",
        checkbox3: "Third party",
        checkbox4: "Applet",
        checkbox5: "Handheld machine",
        headPhoto: "Ticket photos",
        headPhoto1: "Upload pictures",
        headPhoto2: "Only JPG / PNG files can be uploaded, and no more than 1MB (only one picture can be uploaded)",
        edit: "Edit ticket type",
        makForm: "Ticket authority parameters",
        addmakForm: "Add ticket authority",
        FeeMethod: "Traffic mode",
        id_: "ID",
        scenicAreaID_: "Binding attractions",
        passDeviceList: "Binding device",
        useTimesByDay: "Effective times",
        useTimes: "Total times",
        ticketValidDays: "Effective days",
        ticketValidTime: "Effective time",
        addsetForm: "Add ticket authority",
        zone: "Scenic spots",
        second: "Number of days",
        second_: "Please enter the number of days",
        totalSecond: "Please enter the total number of times",
        throughGroupID_: "Binding permission schedule",
        Billing: "Binding billing rules",
        isloadedTicket: "Load ticket",
        totalTime: "Total time (minutes)",
        totalTime_: "Please enter the total time",
        totalday: "Total days",
        totalday_: "Please enter the total number of days",
        pair: "In and out pairing",
        name_: "Equipment name",
        direction: "Access direction",
        editsetForm: "Edit ticket permission parameters",
        Medium: "Please select media",

        Category: "Please select a category",
        Effective: "Please enter the validity period",
        Company: "Please select a scenic spot",
        TicketTypeStartingType: "Please select the starting type",
        TicketDisplayPrice: "Please enter the external sales price",
        jt: "today",
        zt: "yesterday",
        yz: "A week ago",
        qr: "QR code",
        ic: "IC card",
        sfz: "Resident ID card",
        rl: "Face",
        jc: "By number",
        js: "Time",
        ptk: "Ordinary card",
        ttk: "Group card",
        fkm: "Payment code",
        tqk: "Privilege card",
        sfzyhk: "ID card free card",
        areaName: "free regional keywords",
        minAge: "age limit",
        passMode: "free rules",
        passMode1: "By age",
        passMode2: "By region",
        passMode3: "age or region",
        passMode4: "age and region",
        ticketAudioEnable: "Whether to turn on voice",
        ticketAudioEnable0: "do not turn on",
        ticketAudioEnable1: "turn on",
        Type1: "By card processing date",
        Type2: "By natural month (1st of next month)",
        Type3: "Custom",
        Type4: "By deadline",
        loaded: "Loading",
        loaded_: "Do not load",

        nk: "Annual membership card",
        bnk: "Half year membership card",
        jdk: "Quarterly membership card",
        yk: "Monthly membership card",
        zzk: "Stored value card",
        zdrk: "Custom day card",
        zdyk: "Custom monthly card",
        zdnk: "Custom annual card",
        rc: "Do not bind schedule",
        namelength: "Ticket name cannot be longer than 16 characters",
        ticketUseDayslength: "The valid length cannot be greater than 5 characters",
        limitCountlength: "Wechat limit length cannot be greater than 5 characters",
        patchCardlength: "The card replenishment length cannot be greater than 5 characters",
        ticketPricelength: "Ticket price length cannot be greater than 5 characters",
        useTimeslength: "The total number of times cannot be greater than 6 characters",
        useTimesByDaylength: "The number of days cannot be longer than 6 characters",
        useTimesByDay_: "Daily times cannot be greater than the total times",
        ticketTime: "Please enter the time",
        ticketValidTime_: "Time cannot be longer than 4 characters",
        arrList: "Please select the corresponding device",
        ticketValidDays_: "The number of days cannot be longer than 4 characters",
        calcRuleName: "Unbound rule",

    },

    ticketstorage: {
        card: "Ticket / card number",
        card_: "Enter ticket / card number",
        name: "name",
        name_: "Enter name",
        Mobile: "phone number",
        Mobile_: "Enter phone number",
        type: "Ticket type",
        query: "Query information",
        ticketID: "Ticket number",
        ticketPrice: "Unit Price",
        ticketTypeName: "Ticket type name",
        ticketBalance: "balance",
        ticketCate: "Ticket category",
        ticketFeeMethod: "Ticket medium",
        ticketStatus: "Ticket status",
        ticketUserName: "name",
        ticketUserMobile: "phone number",
        ticketStart: "Date of visit",
        subTicketID: "subTicketID",
        ticketEnd: "End time",
        account: "conductor",
        scope: "operation",
        cardmodal: "Edit member personal information",
        ticketTypeName_name: "Cardholder name",
        ticketUserIDNum: "ID number",
        ticketTypeName_card: "Card no",
        ticketUserMobile: "Cardholder telephone",
        ticketStart: "Start of validity period",
        ticketEnd: "End of validity",
        headPhoto: "Photo",
        headPhoto_: "Upload pictures",
        qbzt: "All States",
        wyp: "Ticket not checked",
        yyp: "Checked tickets",
        ytp: "Ticket refunded",
        yzf: "Voided",
        yjy: "Disabled",
        ygs: "Loss reported",
        ygq: "Expired",
        ticketTypeName_qb: "All ticket categories",
        mzzd: "The name cannot be longer than 12 characters",
        sfzzd: "The ID card name cannot be longer than 18 characters",
        sjzzd: "The mobile phone number name cannot be longer than 11 characters",
        sjzzd: "The card length cannot be greater than 24 characters",
        mzzd_: "The name cannot be longer than 10 characters",


    },
    ticketcard: {
        card: "Ticket number/card number",
        card_: "Enter ticket/card number",
        name: "Name",
        name_: "Enter name",
        Mobile: "Phone number",
        Mobile_: "input mobile phone number",
        type: "Ticket type",
        query: "Search information",
        ticketID: "card number",
        ticketTypeName: "Card class name",
        ticketCate: "Ticket category",
        ticketPrice: "unit price",
        ticketFeeMethod: "Ticket medium",
        ticketStatus: "ticket status",
        ticketUserName: "Name",
        ticketUserMobile: "Telephone",
        ticketStart: "Start date",
        ticketEnd: "End Time",
        account: "Conductor",
        ticketBalance: "Balance",
        ticketTypeName_: "Ticket name",
        updataForm: "Edit member personal information",
        subTicketID: "Card parameters",
        ticketUserIDNum: "ID number",
        headPhoto_: "photo",
        primary: "operate",
        headPhoto_primary: "upload image",
        headPhoto: "Only jpg/png files can be uploaded, and no more than 1MB (limited to only one image)",

        updata: "Confirm",
        closeForm: "Cancel",
        qbzt: "all status",
        wyp: "Ticket not checked",
        yyp: "Checked",
        ytp: "Refunded",
        yzf: "Abolished",
        yjy: "disabled",
        ygs: "reported lost",
        ygq: "expired",
        qb: "All tickets",
        error1: "Name cannot be longer than 12 characters",
        error2: "ID card name length cannot be greater than 18 characters",
        error3: "The phone number name cannot be longer than 11 characters",
        success: "Edit information successfully",
        error4: "Failed to edit information",

        error5: "Card length cannot be greater than 24 characters",
        error6: "Phone length cannot be greater than 11 characters",
        error7: "Name cannot be longer than 10 characters",

        ptk: "regular card",
        zzk: "stored value card",
        ttk: "group card",
        nk: "annual membership card",
        bnk: "Membership half year card",
        jdk: "Membership quarterly card",
        yk: "monthly membership card",

        fkm: "payment code",
        tqk: "Privilege Card",
        zdrk: "custom day card",
        zdyk: "custom monthly card",
        zdnk: "custom annual card",
        rl: "human face",
        jc: "count",
        js: "timing",
        rk: "In stock",
        ck: "out of stock",

        headPhoto1: "The uploaded avatar image can only be in JPG or PNG format",

        headPhoto2: "The size of the uploaded avatar image cannot exceed 1MB",

    },
    ticketAuth: {
        id: "ID",
        scenicAreaID: "Affiliated Scenic Spot",
        isEnable: "Whether to enable",
        ticketTypeName: "binding ticket type",
        scope: "operate",
        company: "Affiliated Scenic Spot",
        addForm: "Add witness verification",
        ticket: "Type of ticket",
        out: "Whether to enable",
        resetForm: "reset",
        primary: "Confirm",

        closeForm: "Cancel",
        Error1: "Please select a scenic spot",
        Error2: "Please select a ticket type",
        yes: "Yes",
        no: "no",
        isEnable1: "disabled",
        isEnable2: "enable",
        success: "Add information successfully",
        error: "Failed to add information",
        success1: "Edit information successfully",
        error1: "Failed to edit information",
        delete: "This operation will permanently delete the data, do you want to continue?",
        delete1: "Deleted information successfully",
        delete2: "Failed to delete information",
    },
    ticketpre: {
        id: "discountID",
        discountName: "Offer name",
        scenicAreaID: "Affiliated Scenic Spot",
        discountCategory: "Offer category",
        discountType: "Offer type",
        scope: "operate",
        addForm: "Add discount rules",
        discountName: "Offer name",
        discountName_: "Please enter offer name",
        company: "Affiliated Scenic Spot",
        discountCategory: "Select offer category",

        radio0: "Full amount discount",
        M: "Full",
        je: "reduce",
        y: "Yuan",
        radio1: "full discount",
        da: "beat",
        ze: "fold",
        radio2: "Full quantity discount",
        radio3: "Full discount",
        text: "Discount input instructions, such as 8.8% off, you must enter 88, otherwise it will be invalid, and you will get 10% off. Just enter 90",
        radio4: "Full recharge amount",
        co: "Charge",
        so: "deliver",
        resetForm: "Cancel",
        primary: "Confirm",
        updataForm: "Edit Offer Rules",
        Error1: "Please select a scenic spot",
        Error2: "Select offer category",
        Error3: "Please enter a name",
        label1: "Ticket discount",
        label2: "Recharge Offer",

        error1: "Name length cannot be greater than 24 characters",
        error2: "Please select a discount policy",
        error3: "The data in the rule cannot be empty",
        success: "Add information successfully",
        error: "Failed to add information",
        success1: "Edit information successfully",
        delete: "This operation will permanently delete this data, do you want to continue?",
        warning: "hint",
        delete1: "Delete information successful",
        delete2: "Failed to delete information",
    },
    ticketMatchingRules: {
        discountName: "discountName",
        scenicAreaID: "scenicAreaID",
        ticketType: "ticketType",
        remark: "remark",
        scope: "scope",
        addForm: "addForm",
        updataForm: "updataForm",
        discountName_: "discountName_",
        resetForm: "resetForm",
        primary: "primary",

    },
    ticketprice: {
        id: "ID",
        scenicAreaID: "Affiliated Scenic Spot",
        name: "Spread Rule Name",
        ticketType: "binding ticket type",
        scope: "operate",
        addForm: "Add spread rule",
        company: "Affiliated Scenic Spot",
        type: "Type of ticket",
        gracePeriod: "Completion of grace period",
        label1: "The first stage",
        label2: "second stage",
        label3: "The third phase",
        label4: "fourth stage",
        YItime: "Exceeded time (minutes)",
        YIprice: "Amount to be supplemented (yuan)",
        reset: "Reset",
        primary: "Confirm",
        close: "Cancel",
        updataForm: "Edit name",
        Error1: "Please enter a name",
        Error2: "Please select a scenic spot",
        Error3: "Please select a ticket type",
        error1: "Name length cannot be greater than 12 characters",
        error2: "The first stage timeout period, the amount to be supplemented cannot be empty",
        error3: "The first stage timeout time, the amount to be supplemented is entered incorrectly and cannot be less than 0",
        error4: "Timeout time, the amount to be supplemented is incorrect and cannot be less than 0",
        error5: "The input of the amount to be supplemented in the second stage cannot be empty",
        error6: "The second-order timeout input cannot be empty",
        error7: "The input of the amount to be supplemented in the third stage cannot be empty",
        error8: "The third-order timeout input cannot be empty",
        error9: "The input of the amount to be supplemented in the fourth stage cannot be empty",
        error10: "The fourth-order timeout input cannot be empty",
        error11: "The timeout period cannot be greater than 5 characters",
        error12: "The amount to be supplemented cannot exceed 8 characters",
        successadd: "Add information successfully",
        erroradd: "Failed to add information",
        successedit: "Edit information successfully",
        erroredit: "Failed to edit information",
        delete: "This operation will permanently delete this data, do you want to continue?",
        warning: "hint",
        deletesuccess: "Delete information successful",
        deleteerror: "Failed to delete information",
    },
    ticketBilling: {

        id: "ID",
        calcRuleName: "billing name",
        scenicArea: "Affiliated Scenic Spot",
        calcRuleType: "Billing Type",
        remark: "Billing Instructions",
        scope: "operate",
        addForm: "Added billing rule settings",
        calcRuleName: "Billing rule name",

        billingtype: "Billing Type",
        company: "Affiliated Scenic Spot",
        out: "Is it allowed to go out",
        allowOutTimeSpan: "Time allowed to go out (minutes)",
        isAllowUnitSpanDeduction: "Whether the whole deduction",
        deductionUnitSpan: "Allowable full deduction time (minutes)",
        startPrice: "Starting price (yuan)",
        maxDayAmount: "capped amount (yuan)",
        maxTotalAmount: "Total capped amount (yuan)",
        startFreeTime: "Free time (minutes)",
        graceSpan: "Grace time (minutes)",
        deductionGranularity: "Deduction granularity (yuan)",
        dayType: "Daily cutoff type",

        label1: "time period one",
        start: "start",
        end: "end",
        YItime: "Start billing every few minutes",
        YItime_: "Please enter minutes",
        YIprice: "Deduction amount (yuan)",
        YIprice_: "Please enter the deduction amount",
        label2: "time period two",
        label3: "time period three",
        label4: "time period fou",
        label5: "time period five",
        label6: "Weekend (Saturday, Sunday)",
        label7: "holidays",

        time1: "Holiday start date",
        time2: "select date",
        time3: "holiday end date",
        time4: "Holiday time period",
        reset: "Reset",
        primary: "Confirm",
        updataForm: "edit rules",

        Error1: "Please enter a rule name",
        Error2: "Please select a scenic spot",
        Error3: "Please select a billing method",
        text1: "today",
        text2: "yesterday",
        text3: "a week ago",
        jc: "count",
        js: "timing",
        yes: "Yes",
        no: "no",
        value1: "not allowed",
        value2: "allow",
        value3: "natural day",
        value4: "24 hours calculation",

        error: "Start time period cannot be empty",
        error1: "The first time period is incorrect",
        error2: "Incorrect filling in the second period",
        error3: "Incorrect filling in the third period",
        error4: "The fourth period is incorrectly filled in",
        error5: "The fifth period is incorrectly filled in",

        error6: "The end time of the first period cannot be less than the start time",
        error7: "The end time of the second period cannot be less than the start time",
        error8: "The end time of the third period cannot be less than the start time",
        error9: "The end time of the fourth period cannot be less than the start time",
        error10: "The end time of the fifth period cannot be less than the start time",

        error11: "Filled incorrectly, the end of the first period is greater than the start of the second period",
        error12: "Filled incorrectly, the end of the second period is greater than the start of the third period",
        error13: "Filled in incorrectly, the end of the third period is greater than the start of the fourth period",
        error14: "Filled in incorrectly, the end of the fourth period is greater than the start of the fifth period",
        error15: "Holiday end time cannot be greater than start time",

        zmerror: "Weekend start period cannot be empty",
        zmerror1: "Incorrect filling in the first period of the weekend",
        zmerror2: "Incorrect filling in the second period of the weekend",
        zmerror3: "Incorrect filling in the third period of the weekend",
        zmerror4: "Incorrect filling in the fourth period of the weekend",
        zmerror5: "Incorrect filling in the fifth period of the weekend",
        zmerror6: "The end time of the first period of the weekend cannot be less than the start time",
        zmerror7: "The end time of the second period of the weekend cannot be less than the start time",
        zmerror8: "The end time of the third period of the weekend cannot be less than the start time",
        zmerror9: "The end time of the fourth period of the weekend cannot be less than the start time",
        zmerror10: "The end time of the fifth period of the weekend cannot be less than the start time",

        Terror1: "Filled incorrectly, the end of the first period is greater than the start of the second period",
        Terror2: "Filled incorrectly, the end of the second period is greater than the start of the third period",
        Terror3: "Filled in incorrectly, the end of the third period is greater than the start of the fourth period",
        Terror4: "Filled in incorrectly, the end of the fourth period is greater than the start of the fifth period",
        Terror5: "Filled in incorrectly, the end of the first period of the weekend is greater than the start of the second period",
        Terror6: "Filled in incorrectly, the end of the second period of the weekend is greater than the start of the third period",
        Terror7: "Filled in incorrectly, the end of the third period of the weekend is greater than the start of the fourth period",
        Terror8: "Filled in incorrectly, the end of the fourth period of the weekend is greater than the start of the fifth period",

        Terror9: "Holiday selection start date cannot be empty",
        Terror10: "Holiday selection end date cannot be empty",
        Terror11: "Holiday start time cannot be empty",
        Terror12: "The end time of the holiday cannot be less than the start time",
        Terror13: "Incorrect time period for holidays",
        close: "Cancel",
        successadd: "Add information successfully",
        erroradd: "Failed to add information",
        successedit: "Edit information successfully",
        erroredit: "Failed to edit information",
        delete: "This operation will permanently delete this data, do you want to continue?",
        warning: "hint",
        deletesuccess: "Delete information successful",
        deleteerror: "Failed to delete information",

    },
    tickeTime: {
        id: "id",
        scenicAreaID: "Affiliated Scenic Spot",
        name: "access permission name",
        scope: "operate",
        addForm: "Add time period",

        company: "Affiliated Scenic Spot",
        YItime1: "Monday",
        YItime2: "Tuesday",
        YItime3: "Wednesday",
        YItime4: "Thursday",
        YItime5: "Friday",
        YItime6: "Saturday",
        YItime7: "Sunday",
        YItime8: "holidays",

        start: "start",
        end: "end",
        reset: "Reset",
        primary: "Confirm",
        updataForm: "edit name",
        error1: "Please enter an event name",
        error2: "Please select a scenic spot",
        error3: "Name length cannot be greater than 12 characters",

        errorx1: "The start time of the first segment cannot be empty",
        errorx2: "Monday's end time cannot be less than the start time",
        errorx3: "Tuesday's end time cannot be less than the start time",
        errorx4: "Wednesday's end time cannot be less than the start time",
        errorx5: "Thursday's end time cannot be less than the start time",
        errorx6: "Friday's end time cannot be less than the start time",
        errorx7: "Saturday's end time cannot be less than the start time",
        errorx8: "Sunday's end time cannot be less than the start time",
        errorx9: "The end time of the holiday cannot be less than the start time",

        errorxx1: "Fill in the wrong, the first time period can not be empty, can fill in the second time period",
        errorxx2: "Fill in the wrong, the second time period can not be empty, can fill in the third time period",

        reset: "Reset",
        primary: "Confirm",
        close: "Cancel",
        successadd: "Add information successfully",
        erroradd: "Failed to add information",
        successedit: "Edit information successfully",
        erroredit: "Failed to edit information",
        delete: "This operation will permanently delete this data, do you want to continue?",
        warning: "hint",
        deletesuccess: "Delete information successful",
        deleteerror: "Failed to delete information",

        qy: "Find Controlled Areas",
        add: "Add area to be authorized",
        regionName: "The area it belongs to",
        add: "Add area to be authorized",
        regionCode: "owning code",
        scope: "operate",
        updata: "Authorization control",
        updatatext: "(When none of the regions are selected, the authorization is performed, and the system cancels the control authorization by default)",
        updata: "Authorization control",
        error4: "Please select a ticket type",
        error5: "Add failed, please select region first",
        error6: "Failed to add, cannot add duplicate area",
        error7: "Authorized area succeeded",
        error8: "Authorization area failed",
        error9: "The modified area has been authorized and cannot be deleted. Uncheck the authorization and then operate",
    },
    ticketprint: {
        id: "id",
        namedata: "Affiliated Scenic Spot",
        templateName: "print template name",
        templatePath: "print path",
        useSourceType: "Application scenarios",
        isEnablePrint: "Whether to enable",
        scope: "operate",

        addForm: "Add print template",
        printType: "Printer model",
        company: "Affiliated Scenic Spot",
        prop: "print template",
        propsm: "Print Template Instructions",
        text: "The set print module field must correspond one-to-one with the selected print content",
        seqID: "seqID",
        QR: "QR code",
        ticketID: "Ticket number information",
        ticketTypeName: "Ticket type",
        ticketStartTime: "Effective start time",
        ticketEndTime: "effective end time",
        ticketDisplayPrice: "fare",
        touristName: " Cardholder's Name",
        touristMobile: "Cardholder Mobile Number",
        touristIDCardNum: "Cardholder ID Number",
        reset: "Reset",
        primary: "Confirm",
        close: "Cancel",


        error1: "Please enter a template name",
        error2: "Please enter the path",
        error3: "Please select a scenic spot",
        yes: "yes",
        no: "no",
        print1: "ds",
        print2: "ds80",
        print3: "ms80",
        print4: "drive",
        value1: "window ticket",
        value2: "Self-service ticket machines",

        error: "Name length cannot be greater than 12 characters",
        successadd: "Add information successfully",
        erroradd: "Failed to add information",
        successedit: "Edit information successfully",
        erroredit: "Failed to edit information",
        delete: "This operation will permanently delete this data, do you want to continue?",
        warning: "hint",
        deletesuccess: "Delete information successful",
        deleteerror: "Failed to delete information",

    },

    ticketsharing: {
        id: "id",
        name: "name",
        startPeriod: "start time period",
        endPeriod: "end time period",
        limitCount: "Number of appointments",

        scenicAreaID: "Affiliated Scenic Spot",
        scope: "operate",
        addForm: "Add appointment time slot",
        appointmentConfigName: "Appointment period name",
        company: "Affiliated Scenic Spot",
        prop: "period",
        start: "start",
        end: "end",
        reset: "Reset",
        primary: "Confirm",
        close: "Cancel",
        updataForm: "edit name",
        text: "There is no limit when the number of reservations entered is 0",

        Error1: "Please enter an event name",
        Error2: "Please select a scenic spot",
        Error3: "Please enter the number of reservations",
        Error4: "Name length cannot be greater than 12 characters",
        Error5: "The number of people entered cannot be less than 0",
        Error6: "The length of the number of people cannot be greater than 7 characters",
        Error7: "start time cannot be empty",
        Error8: "End time cannot be empty",
        Error9: "End time cannot be less than start time",

        successadd: "Add information successfully",
        erroradd: "Failed to add information",
        successedit: "Edit information successfully",
        erroredit: "Failed to edit information",
        deletesuccess: "Delete information successful",
        deleteerror: "Failed to delete information",
        delete: "This operation will permanently delete this data, do you want to continue?",
        warning: "hint",

    },
    ticketsetting: {
        id: "id",
        name: "permission name",
        namedata: "Affiliated Scenic Spot",
        isEnable: "Whether to enable",
        scope: "operate",
        addForm: "Add permission",
        label: "Permission role distinction",
        radio_0: "administrator",
        radio_1: "conductor",

        setting: "Permission",
        permissionsetting: "Authority",
        unitsetting: "Unit",
        usersetting: "User",
        print: "Print",
        ticketSetting: "Base",
        tickesSpot: "Scenic spot",
        ticketScenicname: "Attraction",
        ticketChecking: "Site",
        ticketGate: "Equipment",
        ticketEquipment: "Status",
        /*票务业务管理*/

        ticketManagement: "Business",
        ticketMaking: "Ticket type",
        ticketCard: "member",
        ticketStorage: "stored value",
        ticketAuthentication: "witness",
        ticketMerchandise: "商品目录管理",
        ticketMerchandisekind: "商品类别管理",
        ticketPreferential: "Ticket discounts",
        ticketCompensationPrice: "Spread rules",
        ticketBilling: "Billing",
        ticketVenue: "场馆设置",
        ticketVenuesetup: "场馆管理",
        ticketVenueplan: "场次计划",
        ticketTime: "travel schedule",
        ticketGroup: "pass equipment",
        ticketCalendar: "holidays",
        ticketControl: "Regional control",
        ticketTimeSharing: "Time-sharing",
        /*查询报表*/
        sellPrintTicketsgoods: "sellPrintTicketsgoods",
        ticketReport: "Query report",
        ticketrOrder: "Order Details",
        ticketTicket: "Ticket details",
        ticketCode: "Verify",
        ticketImport: "Access details",
        ticketConsume: "Member card",
        ticketActivate: "Activate card",
        ticketConsumestate: "Unused",

        ticketInventory: "门票库存明细",
        ticketMerchandiseReport: "商品库车明细",
        ticketMerchandiseSale: "商品销售明细",
        ticketFlow: "人流量监控",
        ticketStorageReport: "储值卡消费明细",

        ticketInput: "库存管理",
        ticketType: "录入票类",
        ticketCommodity: "录入商品",

        ticketsystem: "System",
        ticketWechat: "WeChat",
        ticketAlipay: "Alipay",
        ticketDatabase: "Database",
        ticketInformation: "system message",
        EquipmentUpgrade: "Equipment upgrade",
        ticketLog: "log management",


        release: "Information Release",
        programRelease: "Program settings",
        graphicRelease: "Graphic settings",
        contentRelease: "Information",
        dataRelease: "Data Kanban",
        ticketStatements: "Financial Statements",

        /*旅行社管理*/
        travelAgencyManagement: 'Travel Agency Management',
        ticketTypeManagement: 'Ticket Type Management',
        orderManagement: 'Order Management',
        rechargeManagement: 'Recharge Management',
        userManagement: 'UserManagement',
        financialStatements: 'Financial statements',

        /*售票*/
        sell: "Ticket management",
        PrintTickets: "Print ticket",
        ScanningTicketing: "Scan the ticket",
        MembershipCard: "Membership card",
        StoredCard: "Stored value",
        Refund: "Refund",
        Collection: "Ticket processing",
        travelAgencyOrderManagement: "TravelAgency Order Management",
        Record: "Shift record",
        Query: "Ticket inquiry",
        Memberrenewal: "Membership renewal",
        sellPrintTickets: "Print ticket",
        sellScanningTicketing: "Scan the ticket",
        sellMembershipCard: "Membership card",
        sellStoredCard: "Stored value",
        sellRefund: "Refund",
        sellCollection: "Ticket processing",
        sellRecord: "Shift record",
        sellQuery: "Ticket inquiry",
        sellMemberrenewal: "Membership renewal",
        sellDifference: "Spread",

        updataForm: "Edit permission",
        Error1: "Please enter a permission name",
        Error2: "Please select a scenic spot",
        label1: "enable",
        label2: "Not enabled",

        error1: "Name length cannot be greater than 12 characters",
        error1: "Please tick the permission functions that need to be opened",

        successadd: "Add information successfully",
        erroradd: "Failed to add information",
        successedit: "Edit information successfully",
        erroredit: "Failed to edit information",
        delete: "This operation will permanently delete this data, do you want to continue?",
        warning: "hint",
        deletesuccess: "Delete information successful",
        deleteerror: "Failed to delete information",



        reset: "Reset",
        primary: "Confirm",
        close: "Cancel",
    },
    ticketuser: {
        id: "ID",
        account: "user name",
        name: "permission name",
        namedata: "Affiliated Scenic Spot",
        namedataid: "Affiliated Scenic Spot ID",
        isEnable: "Whether to enable",
        scope: "operate",
        cz: "reset Password",
        addForm: "New users",
        name_: "user name",
        password: "account password",

        passworddata: "Confirm Password",
        company: "Affiliated Scenic Spot",
        zone: "Attractions",
        user: "Choose permissions",
        updataForm: "edit user",
        password: "new password",
        passworddata_: "Confirm the new password",
        Error1: "Please enter a name",
        Error2: "Please enter password",
        Error3: "Please confirm your password",
        Error4: "Please select permission",
        Error5: "Please select a scenic spot",
        label1: "enable",
        label2: "Not enabled",
        error1: "Name length cannot be greater than 12 characters",
        error2: "Remarks cannot be longer than 64 characters",
        error3: "Password length cannot be greater than 16 characters",
        error4: "The two entered passwords do not match",

        error5: "Password reset successful",
        error6: "Failed to reset password",
        error7: "Cannot delete the account currently in use",

        successadd: "Add information successfully",
        erroradd: "Failed to add information",
        successedit: "Edit information successfully",
        erroredit: "Failed to edit information",
        delete: "This operation will permanently delete this data, do you want to continue?",
        warning: "hint",
        deletesuccess: "Delete information successful",
        deleteerror: "Failed to delete information",
        remarks: "Remark",
        reset: "Reset",
        primary: "Confirm",
        close: "Cancel",
    },

    ticketorder: {

        timeList: "order date",
        createTime: "createTime",
        zhi: "to",
        start: "start",
        end: "end",
        start: "start",
        scenicArea: "scenic spot",
        zone: "Attractions",
        cardlist: "order number",
        name: "name",
        fs: "payment",
        zt: "state",
        qd: "channel",
        yh: "user",
        query: "Inquire",
        orderID: "order number",
        excel: "Export report",
        ticketNum: "number of sheets",
        orderAmount: "order amount",
        preferentialAmount: "Discounted price",
        orderTime: "order time",
        orderPayment: "payment",
        orderStatus: "state",
        account: "conductor",
        scope: "operate",
        orderData: "order details",
        makForm: "Ticket Details",
        ticketID: "ticket number",
        ticketStatus: "ticket status",
        ticketTypeName: "ticket name",
        ticketPrice: "unit price",
        ticketUserName: "Name",
        ticketUserMobile: "phone number",
        ticketUserIDNum: "ID card",
        ticketStart: "play time",
        ticketEnd: "Expiration",
        value1: "all",
        value2: "window ticket",
        value3: "OTAthird party",
        value4: "No public",
        value5: "terminal",
        value6: "Handheld",

        label1: "all",
        label2: "Tickets paid for",
        label3: "Ticket not paid",
        label4: "Refund not refunded",
        label5: "Refund has been refunded",

        fs1: "all",
        fs2: "cash",
        fs3: "WeChat payment code",
        fs4: "Mini Program Payment",
        fs5: "Official account payment",
        fs6: "Alipay payment code",
        fs7: "UnionPay cards",
        fs8: "online payment",
        fs9: "Yangchengtong",
        fs10: "WeChat scan",
        fs11: "Alipay scan",

        text1: "last week",
        text2: "last month",
        text3: "last three months",

        text: "Order Details",
        account_: "all staff",

        error1: "Card length cannot be greater than 24 characters",
        error2: "Phone length cannot be greater than 11 characters",
        error3: "Name cannot be longer than 10 characters",

        zt0: "In stock",
        zt1: "out of stock",

        zt2: "Ticket not checked",
        zt3: "Checked",
        zt4: "Refunded",
        zt5: "Abolished",
        zt6: "disabled",
        zt7: "reported lost",
        zt8: "expired",

        timeListx: "date of purchase",
        card: "Ticket number/card number",

        Mobile: "phone number",
        type: "Ticket type",
        ticketCate: "Ticket category",
        ticketFeeMethod: "Ticket medium",

        ticketUserResidence: "address",
        ticketUserCompany: "unit",
        zoneData: "Attraction parameters",
        makForm_: "Ticket attractions parameter details",
        remainTimesByDay: "total",
        remainTimes: "remaining times",
        remainValidTime: "Time left",

        ptk: "regular card",
        ttk: "group card",
        fkm: "payment code",
        tqk: "Privilege Card",
        nk: "annual card",
        bnk: "half year card",
        jdk: "quarter card",
        yk: "monthly card",
        zdrk: "custom day card",
        zdyk: "custom monthly card",
        zdnk: "custom annual card",
        zzk: "stored value card",
        sfz: "ID card free",

        Error1: "Please select a scenic spot",

        Error2: "Ticket details",
        wu: "none",
        rl: "human face",
        jc: "count",
        js: "timing",

        textx: "Validation details and ticket parameters",
        yztime: "verification time",

        timelist_x: "Date of entry and exit",

        sb: "equipment",
        fx: "direction",
        deviceName: "pass equipment",
        zoneName: "Attractions",
        recordTime: "Admission time",
        direction: "In and out direction",
        temperature: "temperature value",
        openNumber: "Number of door openings",
        fx1: "all",
        fx2: "Enter",
        fx3: "out",
        out: "Access details",
        type_: "All tickets",
        sb_: "All equipment",

        timelist_c: "query date",
        time: "time",
        orderCount: "number of order",
        amount: "order amount",
        actualAmount: "The actual amount",
        refundAmount: "refund amount",
        ticketCount: "number of tickets",
        download: "Financial Statement Details",

        options_company: "All scenic spots",
    },
    ticketlog: {
        options_company: "record date",
        ticketID: "ticket number",
        cz: "Operation type",
        company: "Affiliated Scenic Spot",
        zone: "Attractions",
        dev: "Device List",
        zx: "Results of the",
        query: "Inquire",
        id: "id",
        deviceName: "device name",
        scenicareaName: "Affiliated Scenic Spot",
        zoneName: "Attractions",
        operate: "Operation type",
        operateType: "operate",
        exec_result: "Results of the",
        param1: "parameter1",
        param2: "parameter2",
        recordTime: "record time",
        text1: "last week",
        text2: "last month",
        text3: "last three months",
        label1: "door information",
        label2: "Personnel information",
        label3: "Ticket type",
        label4: "Ticket Information",
        label5: "pass group",
        label6: "schedule",
        label7: "door group information",
        label8: "billing rules",
        label9: "Remote opening",
        label10: "Remote upgrade",
        label11: "Regional control",
        label12: "clean up the database",

        label13: "execution succeed",
        label14: "Failed to execute",
        error: "Ticket length cannot be greater than 18 characters",
    },
    center: {
        accountNumber: "account",
        userId: "userId",
        userName: "user name",
        companyCode: "coding",

        updataForm: "change Password",
        oldPassword: "Old Password",
        newPassword: "new password",
        newPassword1: "Confirm Password",

        Error1: "Old password cannot be empty",
        Error2: "The old password must be 1-12 digits long",
        Error3: "New password cannot be empty",
        Error4: "The new password must be 1-12 digits long",
        Error5: "confirm password can not be blank",
        Error6: "Confirm password length must be 1-12 digits",
        Error7: "The entered confirmation passwords do not match",
        Error8: "password has been updated",
        Error9: "Failed to change the password, please carefully check the old password and the new password",
        Error10: "Failed to change password",

    },
    ticketsell: {
        name: "ticket name",
        ticketDisplayPrice: "show price",
        price: "Ticket sale price",
        num: "Number of tickets purchased",
        price: "Ticket sale price",
        numlist: "total ticket price",
        countList: "The total amount of orders",
        countnum: "total order quantity",
        countList_: "Amount receivable",
        fs: "promotion method",
        zf: "pay",
        zf1: "cash",
        zf2: "payment code",
        zf3: "WeChat",
        zf4: "Alipay",
        zf5: "UnionPay",
        ss: "actually received",
        zl: "change",
        ys: "receivable",
        yh: "discount",
        touristName: "Name",
        touristMobile: "phone number",
        touristIDCardNum: "ID card",
        touristCompany: "Unit information",
        card_id: "read ID card",
        radio_1: "one person one vote",
        radio_2: "one vote",
        add: "Click to vote",
        updataForm: "Scan code",
        updata: "Confirm",

        Error: "cannot be empty or 0",
        Error1: "tourists",
        Error2: "ID not found",
        Error3: "ID card driver not found, or service error, please contact the administrator",
        Error4: "Please scan the payment code",
        Error5: "Payment is successful, ticket purchase is successful",
        Error6: "Payment failed, ticketing failed",
        Error7: "Failed to issue a ticket",
        Error8: "no discount",
        Error9: "Please select the ticket type to sell",
        Error10: "One ticket for multiple people can only choose one ticket type for sale",
        Error11: "Please wait for printing",
        Error12: "Successful ticket purchase",
        Errorx: "Please wait for payment",

        card: "Membership Card Type",
        ticket_card: "member card number",
        IDcardticketMedium: "ID number",
        ICcard_T: "Membership days",
        ICcard_Y: "Membership months",
        ICcard_N: "Membership Years",
        name_: "Name",
        mobile: "phone number",
        countList_d: "Card unit price",
        type: "medium",

        upload: "face photo",
        upload_: "upload image",
        elupload: "Only jpg/png files can be uploaded, and no more than 1MB",

        Errorc1: "Please select a membership card type",
        Errorc2: "Card number cannot be empty",
        Errorc3: "Name cannot be empty",
        Errorc4: "Mobile number cannot be empty",
        Errorc5: "please enter a valid phone number",
        Errorc6: "The ticket purchase is successful, but the printing fails! The print template has not been created, please check the background printing template",
        Errorc7: "The ticket already exists, do you want to resell it?",
        Errorc8: "hint",
        Errorc9: "Please select a ticket type",

        Errorc10: "Please enter a valid number of days, no more than 6000",
        Errorc11: "Please enter a valid number of days",
        Errorc12: "Please enter membership days",
        Errorc13: "Please enter a valid number of months",
        Errorc14: "Please enter a valid number of months, no more than 100",
        Errorc15: "Please enter the number of months of membership",
        Errorc16: "Please enter a valid number of years",
        Errorc17: "Please enter a valid number of years, no more than 30 years",
        Errorc18: "Please enter the number of years of membership",
        Errorc19: "When the ID card medium, enter the ID card number as the card number",
        Errorc20: "Card number cannot be empty",
        Errorc21: "Name cannot be empty",
        Errorc22: "Card length cannot be greater than 24 characters",
        Errorc23: "ID card length cannot exceed 18 characters",
        Errorc24: "Phone length cannot be greater than 11 characters",
        Errorc25: "Name cannot be longer than 10 characters",
        Errorc26: "The card number cannot contain Chinese characters, please confirm your input method, or re-enter",

        cz: "Recharge amount",
        zs: "Recharge gift",
        cr: "The actual amount charged to the card",
        czje1: "Please enter the recharge amount",
        czje2: "The recharge amount cannot be0",

        primary: "Confirm",
        close: "Cancel",

        time: 'time',


        query: 'Check card number',
        ticketID: 'card number',
        ticketID_: 'Process card number',
        id: "id",
        ticketPrice: "unit price",
        ticketTypeName: "Ticket class name",
        ticketCate: "Ticket category",
        ticket_Cate: "Ticket category ID",
        ticketFeeMethod: "Ticket medium",
        ticketBalance: "ticket balance",
        ticketStatus: "ticket status",
        ticketStart: "play date",
        ticketEnd: "End Time",
        subTicketID: "Ticket parameters",
        xf: "Renewal",
        gs: "report loss",
        jg: "Solutions Hanging",
        bk: "Supplementary card",
        y1: "January",
        y3: "March",
        y6: "June",
        j1: "1 season",
        j3: "3 seasons",
        j6: "6 seasons",
        n1: "1 year",
        n2: "2 years",
        n3: "3 years",
        n6: "6 years",
        b1: "half a year",

        time1: "Renewal time (month)",
        time2: "Renewal time (quarter)",
        time3: "Renewal time (year)",
        time4: "Renewal time (days)",
        price1: "Renewal amount",
        price2: "Recharge amount",

        zh: "lump sum",
        list_cz: "Card renewal amount",
        card_xu: "Confirm renewal",
        newcard_ID: "Supplementary card number",
        card_bu: "Confirm",
        qt: "other",

        makForm: "Ticket attractions parameter details",
        scope: "Attractions",
        remainTimesByDay: "total",
        remainTimes: "remaining times",
        remainValidTime: "Time left",
        message1: "Renewal succeeded",
        message2: "Renewal failed",
        message3: "Please select the renewal time first",
        message4: "This operation will disable changing the card, whether to continue",
        message5: "Report lost successfully",
        message6: "Failed to report loss",
        message7: "This operation will unlink and change the card, whether to continue",
        message8: "Unhooked successfully",
        message9: "Unlink failed",
        message10: "Please enter a content of the query",
        message11: "The renewal amount cannot be empty, please enter the amount",
        message12: "The renewal amount is incorrect, please enter the correct amount",
        message13: "Please select a renewal time",

        message14: "The number of days for renewal cannot exceed 5000 days",
        message15: "The number of months for renewal cannot be greater than 100 months",
        message16: "The number of years of renewal cannot exceed 20 years",
        message17: "The card number cannot be empty, please check the selected card number",
        message18: "This operation will complete the card replenishment operation, the new card will completely inherit the information data of the old card, whether to continue",
        message19: "Supplementary card numbers cannot be the same",
        message20: "Supplementary card number cannot be empty",
        message21: "Card replacement is successful",
        message22: "Card replacement failed",
        message23: "The status of the card cannot be replenished",
        message24: "Regular cards cannot be replaced",
        message25: "Group card cannot be replaced",
        message26: "The card information is obtained successfully, please follow the steps below",
        message27: "The status of the card cannot be renewed",
        message28: "Regular card cannot be renewed",
        message29: "Group card cannot be renewed",
        ticketMedium: "Ticket medium",
        ticketBalance: "balance",
        return_card: "Enter card number/ticket number/order number",
        ticketID_return: "ticket number",
        isRefund: "Is it refundable",
        refundAmount: "balance",
        orderPayment: "payment method",
        ticketFeeMethod_: "Billing method",
        list_yt: "should be withdrawn",
        list_sx: "handling fee",
        list_st: "Retire",
        orderPaymentID: "Refund ID",
        zfisRefund: "refund payment",
        zf6: "WeChat payment code",
        zf7: "Alipay payment code",
        zf8: "Official account payment",
        zf9: "Mini Program Payment",
        refund: "Confirm refund",
        refund_1: "non-refundable",
        refund_2: "Refundable",

        message30: "Please enter ticket number or order number",
        message31: "There is no refundable ticket in the ticket number or order, you can go to the ticket to check the specific status information",
        message34: "Please select the ticket to be refunded",
        message32: "Refund is successful",
        message33: "Failed to refund",

        qp: "Ticket collection",

        hx_: "Ticket write-off",
        qplist: "Ticket Processing/Ticket Pickup",
        text: "By inquiring about tourist information, the electronic QR code in the hands of tourists can be printed into a paper QR code. Regardless of ticket status. Select the tickets you want to print, or select all to print.",
        cardlist: "order/ticket number",
        print: "print tickets",
        orderID: "Order",
        account: "conductor",
        ticketUserCompany: "unit",
        qplist_: "Ticket Processing/Ticket Verification",
        text_: "By querying the tourist information, the order is an 18-digit number that starts with DD, and the ticket number is an 18-digit number that starts with a single letter. If the ticket status is unchecked, after clicking the check-off, the ticket cannot pass through the gates, etc. equipment",
        cardlist_: "Enter ticket number/or order number",
        cardlist_list: "Ticket/Order Number",
        query_list: "search information",
        query_: "Query the ticket information that needs to be written off",
        orderIDhx: "Write off all",
        hx: "write off",
        warning1: "Please enter the data to be queried",
        warning2: "Card length cannot be greater than 24 characters",
        warning3: "Name cannot be longer than 10 characters",
        warning4: "ID card length cannot exceed 18 characters",
        warning5: "This operation will write off the ticket, do you want to continue",
        warning6: "Write-off successful",
        warning7: "Write-off failed",
        warning8: "Write-off failed, please contact the administrator",
        warning9: "This operation will write off all the tickets in the order. Do you want to continue?",
        warning10: "Please select the ticket you want to print",
        warning11: "This operation will print the ticket, do you want to continue",
        warning12: "print successfully",
        warning13: "print failed",
        warning14: "Failed to print, please contact the administrator",
        warning15: "Cancel printing",


        ticketCount: "total",
        OrdinaryCard: "regular card",
        StoreCard: "stored value",
        MembershipCard: "member",
        GroupCard: "group card",
        RticketCount: "Number of refunds",
        amount: "Total cashier",
        Cash: "Cash",
        Alipay: "Alipay",
        WeChat: "WeChat",
        UnionPay: "UnionPay",
        Ramount: "total refund",
        RCash: "cash back",
        RAlipay: "Refund Alipay",
        RWeChat: "Back WeChat",
        RUnionPay: "Withdrawal from UnionPay",
        Samount: "Total paid-in",
        xd: "Order record",
        xq: "Ticket details record",
        ticketNum: "number of sheets",
        orderAmount: "order amount",
        preferentialAmount: "Discounted price",
        orderTime: "order time",
        orderPayment: "payment method",
        orderStatus: "state",
        id_query: "Modify payment",
        orderData: "order details",
        hidelist: "Ticket details record",
        ticketSum: "Number of tickets purchased",
        refundTicketSum: "Number of refunds",
        actualAmount: "Actual sales amount",
        ticketRechargeAmount: "balance",
        printticket: "Print",
        updataForm_: "Edit payment method",

        zoneData: "Corresponding attractions parameters",

    },

    ticketCollection: {
        ticketLibraryList: "ticketLibraryList",
        warehousingOperation: "warehousingOperation",
        operationRecords: "operationRecords",
        ticketLibraryName: "ticketLibraryName",
        residueNum: "Remaining quantity",
        operator: "operator",
        startNum: "start number",
        endNum: "end number",
        num: "number",
        add: "Add",
        addTitle: "Add title",
        receiptQuantity: "Receipt quantity",
        warehousingTime: "Warehousing time",
        operatingTime: "Operating time",
        ticketsReceivedNum: "Number of tickets received",
        ticketsReceivedTime: "Ticket collection time",
        ticketsReceivedCollector: "Ticket collector",
        returnedNum: "Returned quantity",
        returnedstartNum: "Starting number for stock return",
        returnedendNum: "Ending number for stock return",
        returnedCollector: "Returned personnel",
        returnedTime: "Return time",
        totalInboundQuantity: "Total inbound quantity",
        totalTicketsReceivedNum: "Total number of tickets received",
        totalReturnedNum: "Total quantity of returned inventory",
        totalRemainingQuantity: "Total remaining quantity",
        remark: "remark"
    },


    ticket: {
        message1: "Account cannot be empty",
        message2: "password can not be blank",
        message3: "Login successful, loading",
        message4: "Login failed, service not connected",

        yes: 'Yes',
        no: "No",
        remark: 'Remark',
        reset: "Reset",
        scope: "Operation",
        primary: "Confirm",
        close: "Close",

        successadd: "Information added successfully",
        erroradd: "Failed to add information",
        successedit: "Edit information succeeded",
        erroredit: "Failed to edit information",
        delete: "This operation will permanently delete the data. Do you want to continue?",
        warning: "Warning",
        deletesuccess: "Information deleted successfully",
        deleteerror: "Failed to delete information",
        //补译
        setqx: "Customize distribution permissions",
        deviceParam: "Basic parameters of equipment",
        ticketTypeParam: "Ticket permission parameters",
        ordinaryTicketParam: "Ordinary ticket information",
        membershipTicketParam: " Membership Card Information",
        Errorx13: "Processing...",
        company: "Please select a scenic spot",
        addForm_: "Device synchronization settings",
        deviceSoftVersion: "Controller version",
        zdyqx_query: "Custom permission distribution",
        tt: "Synchronization description: The backend will default to synchronizing data with the device in real-time. If there is frequent interaction in the backend (during peak season in the park), synchronization can be turned off and the system switches to the device actively requesting software backend, greatly reducing backend server pressure",
        company_: "Scenic Area Belonging to",
        tt_: "Synchronize or not",
        tt_title: "Sync Settings",
        addFormdata_: "More ticket category settings",
        isIncomeDistribution: "Whether to allocate income",
        touristType: "Tourist type",
        enterMethod: "lockage fashion",
        isAppointmentEnable: "Do you want to enable WeChat reservation",
        saleEndTime: "WeChat order limit time",
        isGetTicketPass: "Whether to collect tickets for passage",
        isRefundCheck: "Refund Review",
        wx: "WeChat booking instructions",
        isRealName: "Do you need an ID card",
        enterMode: "Admission time",
        reservationInstructions: "Usage method",
        detailsExplain: "Game Description",
        makForm_gj: "Ticket Class Advanced Parameter List",
        add_gj: "Add advanced parameters for ticket categories",
        id: "Serial Number",
        personTicketBindingMode: "ID card mode",
        enablePasswordMode: "Read password review",
        checkRefundMode: "Is it mandatory to refund the ticket",
        addForm_gjlist: "Adding advanced ticket parameters",
        checkPassword: "Audit password",
        updataForm_gjlist: "Edit advanced ticket parameters",
        enterMethod1: "One person, one vote",
        enterMethod2: "One vote for multiple people",
        touristType1: "ordinary",
        touristType2: "Children under 1.3 meters and 6 years old (including)",
        touristType3: "minor",
        touristType4: "student",
        touristType5: "old people",
        touristType6: "deformed man",
        touristType7: "Active military personnel",
        touristType8: "Family members of active duty soldiers",
        touristType9: "Military Retirees",
        touristType10: "Disabled soldiers",
        touristType11: "family dependants of the martyr",
        touristType12: "Public security police",
        touristType13: "Fire rescue personnel",
        touristType14: "Medical staff",
        touristType15: "teacher",
        touristType16: "Local registered residence registration personnel",
        touristType17: "tour guide",
        touristType18: "Companion personnel",
        touristType19: "Media reporters",
        touristType20: "Policy regulations and preferential personnel",
        touristType21: "college student",
        touristType22: "middle school student",
        touristType23: "pupil",
        touristType24: "One vote for multiple people",
        personTicketBindingMode1: "One certificate, one person",
        personTicketBindingMode2: "Multiple people with one certificate",
        enablePasswordMode1: "Not turned on",
        enablePasswordMode2: "open",
        /* 补译*/
        areaName: "When the type is ID card free card, the region keyword cannot be empty",
        minAge: "When the type is a free ID card, the age cannot be blank",
        minAge1: "When the type is a free ID card, the regional keyword cannot exceed 180 characters",
        minAge2: "When the type is a free ID card, the age cannot be greater than 3 characters",
        minAge3: "When the type is a free ID card, the type must be selected",
        minAge4: " The time span of the restriction cannot be greater than 1 year",
        card: "Edit the membership information according to the template, and after selecting the corresponding ticket type, the status can only be selected as not verified or not activated. If not verified, the card type will be sold directly, and the card will be used directly. If not activated, the card will be sold, but it must be activated again in the window. The effective start time of the card is the activation time",
        upload: "SELECT FILE",
        upload1: "Upload member information",
        excel: "Export member information",
        jihuo: "activation",

        upload2: "Upload failed, please carefully verify personnel information",
        jihuo1: "This operation will activate the card. Do you want to continue ",
        jihuo2: "This operation will activate the card, and after activation, the card will be available for use",
        jihuo3: "Activation successful",
        jihuo4: "Activation failed",
        cardtext: "Membership Card Information",

        ticketRefund: "Refund Details",
        Supplementary: "Supplementary printing details",
        goods: " Product Settings",
        shops: "Store Management",
        gatalogue: "catalogue",
        commodity: "Inventory",
        goodsloading: "Product Entry",
        Inventory: "Product inventory details",
        Commoditysales: "Product Order Details",
        Salesdetails: "Product sales details",
        Entry: "Ticket Entry",
        Ticket_Inventory: "Ticket inventory",
        Warehouse: "Inventory management",
        Shareholder: "Shareholder management",
        mobileTerminal: "mobile terminal",
        Share: "Shareholders' equity",
        Statement: "Revenue Details",
        scan: "Scan ticket sales",
        sellgoods: "Sale of goods",
        useType: "Use type",
        Mobile: "phone",
        Mobile1: "Enter phone number",
        actualOrderAmount: "Actual order amount",
        inValidOrderCount: "Number of invalid orders",
        refundOrderAmount: "Refund Order Amount",
        refundOrderCount: "Number of refunded orders",
        totalOrderCount: " Total number of orders",
        totalValidOrderAmount: "Effective order amount",
        totalValidOrderCount: "Number of valid orders",
        touristIDCardNum: "ID card",
        ota: "OTA Source",
        lyd: "Origin",
        unUsedTicketAmount: "Unverified invoice amount",
        unUsedTicketCount: "Number of unverified tickets",
        usedTicketAmount: "Write-off invoice amount",
        usedTicketCount: "Number of verified tickets",
        refundTicketAmount: "Refund amount",
        refundTicketCount: "Number of ticket refunds",
        tickettime: "Ticket purchase time",
        headPhoto: "photo",
        wu: "not have",
        ticketChannel: "Distribution source",
        totalCount: " Total number of people",
        enterCount: " Number of Entries",
        outCount: "Number of employees",
        realTimeCount: " Number of attendees",
        zoneName: "Attractions",
        deviceName: "device",
        enterCount1: "Entry and exit details",
        query1: "Entry and exit detailed statistics",
        query2: "Equipment Entry and Exit Details",
        headPhoto: "photo",
        ticket_card: "Enter membership card number",
        IDcardticketMedium: "Enter ID number",
        transPrice: "Transaction unit price",
        ticketStatus: "Order time",
        rticket: "Ticket refund",
        rgoods: "Return of goods",
        ticket_qz: "Forced refund",
        return_text: "Compulsory refund of tickets (cancelled or used tickets are forcibly refunded here)",
        isRefundCheck: "Reviewed or not",
        refundCheckStatus: "Audit status",
        usedTime: "Usage time",
        cz: "operate",
        RefundCheck: "Submit for review",
        printtext1: "【Ticket printing】",
        printtext2: "【Order printing】The entered query number is an order number starting with DD, and there is only one type of ticket under the order. Therefore, when printing the order, the ticket under the order can only be printed as a QR code, and the permissions in the QR code can exceed the corresponding ticket permission times",
        printtext3: "Order printing",
        hx1: "Scenic spot verification",
        hx2: "Batch verification",
        hx3: "Global Write-off",
        hx4: "【Scenic spot verification】By querying tourist information, the order starts with an 18 digit number starting with DD, and the ticket number starts with a single letter. If the ticket status is unchecked, check the information that can be verified and click on the verification to reduce the number of passes under the corresponding attraction once",
        hx5: "【Global Write-off】By querying tourist information, the order is an 18-digit number starting with DD, and the ticket number is an 18-digit number starting with a single letter. If the ticket status is unchecked, click 'cancel' and the ticket status will be directly changed to 'checked' (use with caution)",
        hx6: "【Batch verification】By querying the 18 digit number starting with DD in tourist orders, the number of ticket passes for the corresponding attraction can be reduced in bulk based on the number of available tickets found",
        totalTicketCount: "Ticket quantity",
        validTicketCount: "Number of Passeable Tickets",
        totalValidTimes: "Number of Passes Available",
        hx7: "Maximum Write-off Amount",
        hx8: "Write-off quantity",
        hx9: "Verification of tickets",
        checkPeopleCount: "Enter the quantity to be written off",
        hxnum: "The quantity to be written off cannot be greater than the maximum number that can be written off",
        msgCode: "Verification successful",
        ticketID: "Enter the order number that needs to be queried",
        ticketIDlength: "The input length cannot be greater than 24 characters",
        Error: "This operation will only issue one ticket, which will be recorded in the supplementary printing details. Do you want to continue?",
        printwarning: "Order printing failed, the order can only contain one ticket type",
        printwarning1: "Data error, printing order failed",

        printwarning2: "This operation will print the ticket and record it in the supplementary printing details. Do you want to continue?",
        settledAmount: " Settlement amount",
        unSettledAmount: "Unsettled",
        Samount_dq: "Current total amount",
        Samount_dq_: "Current total refund",
        Samount_last: "Current actual receipts",
        settledAmount_last: "Current settlement",
        unSettledAmount_last: "Unsettled",
        addjjb: "Shift handover operation",
        addgoods: "Inventory",
        goodslist: "Product sales details",
        changeShiftsName: "Shift handover",
        amount: "Total amount received",
        settledAmount: "Settlement amount",
        startTime: "Start time of shift handover",
        endTime: "End time of shift handover",
        operator: " presenter",
        operator1: " This operation will submit the current received amount for settlement and generate a handover record. Do you want to continue",
        operator2: " prompt",
        operator3: " Submitted successfully",
        operator4: " Submission failed",
        query_pl: " Query orders",
        rquery1: " Refund Review Details",
        rquery2: " Refund Details",
        orderPayment: "Payment method",
        createTime: " Submission time",
        orderAmount: " Order amount",
        account: " Submitted for review by",
        refundCheckStatus: " Audit status",
        orderTime: "Refund time",
        SRoot1: "in review",
        SRoot2: "Audited",
        SRoot3: "Rejected",
        SRoot4: "Audit failed",
        textx1: " This operation will review the successful amount and generate a refund order. Do you want to continue",
        textx2: "Audit successful",
        textx3: "This operation will reject the refund request for this ticket. Do you want to continue",
        text4: "Rejected successfully",
        text5: "Rejection failed",
        ticket1: "Ticket Report",
        ticketjjb: "change shifts",
        ticket_zh: "Comprehensive query",
        tj: "condition",
        queryly: "Export Source Report",
        ticketTypeName: "Ticket type",
        ticketPrice: "Ticket unit price",

        ticketCount: " Sales quantity",
        amount1: "total",
        offline_ticketCount: " Offline sales",
        offline_amount: " Offline sales amount",
        OTA_ticketCount: " Online sales quantity",
        OTA_amount: " Online sales amount",

        amount2: "Total amount",
        totalTicketCount: "Total number of tickets sold",
        window_cashTicketCount: " Number of cash tickets at the window",
        window_cash: "  Window cash receipt",
        window_wxTicketCount: "Number of WeChat votes in the window",
        window_wxAmount: "Window WeChat cashier",
        window_zfbTicketCount: "Number of Alipay tickets in the window",
        window_zfbAmount: "Window Alipay cashier",
        terminal_wxTicketCount: "Number of terminal WeChat votes",
        terminal_wxAmount: "Terminal WeChat cashier",
        terminal_zfbTicketCount: "Terminal Alipay votes",
        terminal_zfbAmount: "Terminal Alipay cashier",
        OTA_ticketCount: "Number of OTA distribution tickets",
        OTA_amount: "OTA distribution amount",
        shareHolderName: "Income company",
        shareHolder: "income",
        refundCount: "Number of ticket refunds",
        refundTodayTicketCount: "Number of orders placed on the day of refund",
        refundPreviousTicketCount: "Number of orders placed on the previous day",
        businessTicketCount: "Count transaction votes",
        textly1: "Details of online distribution channels",
        textly2: "Ticket type statistics",
        textly3: "Ticket source statistics",
        ptkly: "Source details",
        textentry: "Edit the ticket information according to the template, and after selecting the corresponding ticket type, the status can only be selected as not checked or received. If not checked is selected, the ticket type will be sold directly and the ticket will be used directly! The received tickets will be placed in the ticket warehouse for front-end sales use",
        textexcel: "Upload files",
        uptabledata: "Upload ticket information",
        textentry1: "After the successful entry operation, the ticket information can be viewed in the ticket inventory. After the import operation is successful in an unverified ticket state. The ticket is directly bound to the ticket seller's account for sale. And an order will be generated. Check in the order details and the ticket information will also be stored in the ticket inventory report",
        textentry2: "Import time",
        textentry3: "Inbound ticket number",
        textentry4: "Delete ticket information",
        ticketzt: "Import Status",
        ticketzt1: "Received",
        ticketzt2: "Upload failed, please carefully check the ticket information",
        qx: "Cancel",
        ticketzt3: "The ticket length cannot exceed 18 digits! Upload validation failed",
        ticketzt4: "The ticket length cannot be empty! Upload validation failed",
        ticketzt5: "The ticket number contains Chinese or special characters, and the upload verification failed",
        ticketzt6: "There are duplicate ticket numbers",
        ticketzt7: "Please upload the file",
        ticketzt8: "Please select a scenic spot",
        ticketzt9: "Please select a status",
        ticketzt10: "Please select the bound ticket seller",
        ticketzt11: "Please select the bound ticket type",
        ticketzt12: "Successfully uploaded information",
        ticketzt13: "Failed to upload information",
        ticketzt14: " Attachment format error, please delete and upload again",
        ticketzt15: " Please upload the attachment",
        ticketzt16: " Please select the ticket that needs to be deleted",
        ticketzt17: "This operation will delete the selected ticket",
        ticketztx: "Unchecked tickets",
    },

    btn: {
        add: "Add",
        edit: "Edit",
        delete: "Delete",
        query: "Query",
        download: "download",
        submit: "Submit",
        cancel: "Cancel",
        reset: "Reset",
        personnelAuthorization: "personnel Authorization",
        text2: "technical support",
        text3: "Please log in using IE9 and above, EDGE, Google, or Opera browsers",
        text4: " Account cannot be empty",
        text5: " Password cannot be empty",
        text6: "Login successful, loading.....",
        text7: "Login failed, service not connected",
        touristMobile: "The length of the phone cannot exceed 11 digits",
        touristIDCardNum: "The length of the ID card cannot exceed 18 digits",
        xlabel1: "not have",
        xlabel2: "WeChat official account",
        xlabel3: "Self service terminal",
        xlabel4: "OTA",
        xlabel5: "WeChat mini program",
    },
    egsRouteName: {
        home: 'home',
        personnelList: 'personnelList'
    },
    rightMenu: {
        close: 'close',
        closeOther: 'closeOther',
        closeAll: 'closeAll'
    },
    role: {
        superAdmin: 'superAdmin',
        admin: 'admin',
        ordinary: 'ordinary'
    },
    userDropdownMenu: {
        basicInfor: 'basicInfor',
        changePassword: 'changePassword',
        logout: 'logout'
    },
    message: {
        selectNoData: 'No data found',
    },

    ...enLocale //  合并element-ui内置翻译
}

export default en


// WEBPACK FOOTER //
// ./src/i18n/lang/en.js